<template>
  <div>
    <div v-if="waitingScanResponse" id="waiting-screen">
      <b-spinner class="spinner-color"></b-spinner>
    </div>

    <ScanMenuModal
      @onValidateClicked="onValidateClicked"
    ></ScanMenuModal>

    <ScanResultModal
      :is-success="isSuccess"
      :should-display-insist-button="shouldDisplayInsistButton"
      :identifier="identifier"
      :has-gained-lampion="hasGainedLampion"
      @onVerifyClicked="goToVerifyMatch(false)"
      @onInsistClicked="goToVerifyMatch(true)"
      @onEndClicked="$bvModal.hide('scan-result-modal')"
    ></ScanResultModal>

  </div>
</template>

<script>
import api from "../../services/api";
import ScanMenuModal from "./ScanMenuModal";
import ScanResultModal from "./ScanResultModal";

export default {
  components:{
    ScanMenuModal,
    ScanResultModal,
  },

  data() {
    return {
      waitingScanResponse: false,
      lat: null,
      lng: null,

      isSuccess: false,
      shouldDisplayInsistButton: false,
      identifier: "",
      hasGainedLampion: false,

      scannedIdentifier: null
    };
  },

  methods: {
    async onValidateClicked(data) {
      this.$nextTick(()=>{
        this.$bvModal.hide("scan-menu-modal")
      })
      this.waitingScanResponse = true
      if(data.enabledPosition === true){
        await this.getUserPosition()
      }
      this.sendMatchAttempt(data)
    },

    async getUserPosition(){
      if (navigator.geolocation) {
        await navigator.geolocation.getCurrentPosition(
          (position) => {
            this.lat = position.coords.latitude;
            this.lng = position.coords.longitude;
          },
          () => {
          },
          {
            timeout: 3000
          }
        );
      }
    },

    sendMatchAttempt(scanMenuData){
      let data = new FormData()
      let scannedIdentifier = JSON.stringify({
        'licensePlate': scanMenuData.identifierType === "LICENCE_PLATE" ? scanMenuData.identifier : null,
        'vin': scanMenuData.identifierType === "VIN" ? scanMenuData.identifier : null,
        'bicycode': scanMenuData.identifierType === "BICYCODE" ? scanMenuData.identifier : null,
        'serialNumber': scanMenuData.identifierType === "SERIAL_NUMBER" ? scanMenuData.identifier : null,
        'windowEngraving': scanMenuData.identifierType === "WINDOW_ENGRAVING" ? scanMenuData.identifier : null,
        'annonceId': this.$store.state.lastAnnonceMatchAttemptId,
        'creatorName': this.$store.getters.username,
        'latitude' : this.lat,
        'longitude' : this.lng,
        'date': Date.now(),
        'isOcr': false,
        'isVocalCommand': false,
        'isText': true
      })
      data.append('scannedIdentifier', scannedIdentifier)

      api({
        method: "POST",
        url: "/scannedIdentifier/getMatchResult",
        data: data
      })
        .then((response) => {
          this.scannedIdentifier = response.data

          this.isSuccess = response.data.annonceId != null
          this.shouldDisplayInsistButton = !this.isSuccess && this.$store.state.lastAnnonceMatchAttemptId != null
          this.hasGainedLampion = response.data.lampionsGained > 0
          this.identifier = scanMenuData.identifier

          if(this.shouldDisplayInsistButton){
            this.scannedIdentifier.annonceId = this.$store.state.lastAnnonceMatchAttemptId
          }

          //reset pour prochaines tentatives de matchs
          this.$store.state.lastAnnonceMatchAttemptId = null

          this.$bvModal.show('scan-result-modal')
          this.waitingScanResponse = false
        })
        .catch(error => {
          if (!error.response) {
            console.log("error", error)
          }
        })
    },

    goToVerifyMatch(insist){
      this.$bvModal.hide('scan-result-modal')
      this.$router.push({
        name: "VerifyMatch",
        params: {
          'scannedIdentifier': this.scannedIdentifier,
          'identifier': this.identifier,
          'didInsist': insist,
          'lat': this.lat,
          'lng': this.lng
        }
      })
    },
  },
};
</script>

<style>
#waiting-screen{
  z-index: 10;
  background-color: rgba(0, 0, 0, 0.6);
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/views/match/ScanMenu.vue